import { Candidate } from "../../models/Candidate";
import { ReactComponent as ExternalLink } from '../../assets/svg/external-link.svg';
import { DocumentViewer } from "../Shared/DocumentViewer";
import { getCandidateCVURL } from "../../helpers/Common";
import useErrorPage from "../../hooks/useErrorPage";
import { downloadCandidateResume } from "../../services/CandidateService";
import { Button } from "../Shared/Buttons/Button";

interface Props {
    candidate: Candidate;
    styles: any;
    cvTranslationText: string;
    fileName: string;
}

export const CVTab: React.FC<Props> = (props) => {
    const styles = props.styles;  
    const [toErrorPage] = useErrorPage();
    const zoom = 1;

    async function downloadApplicantCV() {
        await downloadCandidateResume(props.cvTranslationText, props.fileName)
        .then((response: any) => {

        })
        .catch((error) => {
            toErrorPage(error);            
        });
    }

    async function handleViewFullScreen() {
        try {
            const url = getCandidateCVURL(props.cvTranslationText, false, true);
            if (props.fileName.toLowerCase().endsWith('.pdf')) {
                window.open(url, 'CV', '_blank');
            } else {
                // For DOC/DOCX, download directly without opening blank tab
                await downloadCandidateResume(props.cvTranslationText, props.fileName);
            }
        } catch (error) {
            toErrorPage(error);
        }
    }

    return (
        <>
            <div style={styles.mainWrapper}>
                <div style={styles.rowWrapper}>
                    <div style={styles.text}>CV</div>
                    <div style={styles.link} onClick={handleViewFullScreen}>
                        View Full Screen <ExternalLink style={styles.icon} />
                    </div>
                    <Button style={styles.button} onClick={downloadApplicantCV}>{"Download"}</Button>
                </div>
                <div style={styles.holder}>
                    {props.cvTranslationText && 
                        <div style={styles.cvWrapper}>
                            <DocumentViewer 
                                document={getCandidateCVURL(props.cvTranslationText)} 
                                styles={{...styles.documentViewer, transform: `scale(${zoom})`}}
                            />
                            <div style={styles.cvOverlay} onClick={handleViewFullScreen} />
                        </div>
                    }
                    <p style={styles.name}>{props.fileName}</p>
                </div>
            </div>
        </>
    )
}